import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LanguageSelectorFormComponent } from '@shared/modules/translations/components/language-selector-form/language-selector-form.component';
import { SelectControlModule } from '@shared/modules/form-controls/select-control/select-control.module';

@NgModule({
  declarations: [LanguageSelectorFormComponent],
  imports: [CommonModule, ReactiveFormsModule, SelectControlModule],
  exports: [LanguageSelectorFormComponent]
})
export class LanguageSelectorFormModule {}
